const datesArray = [
  { date: "Dec 1, 2025", isSelected: true },
  { date: "December 1, 2025", isSelected: false },
  { date: "12-1-25", isSelected: false },
  { date: "12-1-2025", isSelected: false },
  { date: "12-01-25", isSelected: false },
  { date: "12-01-2025", isSelected: false },
  { date: "12/1/25", isSelected: false },
  { date: "12/1/2025", isSelected: false },
  { date: "12/01/25", isSelected: false },
  { date: "12/01/2025", isSelected: false },
  { date: "1 Dec, 2025", isSelected: false },
  { date: "1 December, 2025", isSelected: false },
  { date: "1-12-25", isSelected: false },
  { date: "1-12-2025", isSelected: false },
  { date: "01-12-25", isSelected: false },
  { date: "01-12-2025", isSelected: false },
  { date: "1/12/25", isSelected: false },
  { date: "1/12/2025", isSelected: false },
  { date: "01/12/25", isSelected: false },
  { date: "01/12/2025", isSelected: false }
];

export default datesArray;